import { apiSlice } from "./api/apiSlice";
import { configureStore } from "@reduxjs/toolkit";
import searchReducer from "./products/productSlice";
import comboReducer from "./combo/comboSlice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    searchText: searchReducer,
    comboProducts: comboReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});
export default store;
